import moment from 'jalali-moment'
import React, { useState } from 'react'
import { MoneyPoolTransactionTypes } from 'utilities/helper/moneyPools'
import deposit_icon from 'assets/images/rectangle/ic_deposit.svg'
import endurance_icon from 'assets/images/rectangle/ic_endurance.svg'
import west_vector_icon from 'assets/images/rectangle/west_vector.svg'
import CustomBottomSheet from '../../../../../components/bottomSheet'
import TransactionDetails from './transactionDetails'
import { ConvertJalaliDate } from '../../../../../utilities/helper/digitToMonth'
import {
    getTransactionStatusText,
    isCashin,
    TransactionStatusText,
} from '../../../../../utilities/helper/Funds'

interface IItemProps {
    item: IMoneyPoolTransactionResult
    isManager: boolean
}

export default function Item({ item, isManager }: IItemProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const statusText = TransactionStatusText[getTransactionStatusText(item)]
    const cashin = isCashin(item)
    return (
        <>
            <div className="mx-4 my-1.5 rounded-[10px] border border-stroke bg-white p-3">
                {/* amount + icon (right) and destination name */}
                <div className="flex flex-row items-baseline">
                    <img
                        className="h-4 w-4 self-center"
                        src={cashin ? deposit_icon : endurance_icon}
                        alt=""
                    />
                    <p
                        className={`mr-2 shrink-0 font-bold text-base ${
                            cashin ? 'text-success-1' : 'text-danger'
                        }`}
                    >
                        {item.amount && item.amount.toLocaleString()} تومان
                    </p>
                    <p className="mr-2 flex-1 text-right font-bold text-base text-black">
                        {item.poolship_name}
                    </p>
                </div>

                {/* status chip (right, mt-3) + type (left, mt-4) */}
                <div className="flex flex-row-reverse items-start justify-between">
                    {statusText ? (
                        <p className="mt-3 rounded-[10px] bg-blue-6 px-3 py-0.5 text-sm font-bold text-blue-5">
                            {statusText}
                        </p>
                    ) : (
                        <span className="mt-3" />
                    )}
                    <p className="mt-4 text-sm text-text-secondary">
                        {MoneyPoolTransactionTypes[item.type]}
                    </p>
                </div>

                {/* detail link (left) + date/time (right) */}
                <div className="mt-4 flex flex-row-reverse items-center justify-between">
                    <p className="text-xs text-text-secondary">
                        {(() => {
                            const date =
                                item?.jalali_time &&
                                ConvertJalaliDate(item.jalali_time)
                            const parsed = moment(
                                item.jalali_time,
                                'jYYYY-jMM-jDD HH:mm:ss.SSS'
                            )
                            const time = parsed.isValid()
                                ? parsed.format('HH:mm:ss')
                                : 'ساعت نامعتبر'
                            return time === '00:00:00'
                                ? date
                                : `${date} | ${time}`
                        })()}
                    </p>
                    <button
                        className="flex items-center gap-2"
                        onClick={() => setIsOpen(true)}
                    >
                        <img
                            className="h-3.5 w-3.5"
                            src={west_vector_icon}
                            alt=""
                        />
                        <span className="text-sm font-bold text-blue-1">
                            جزئیات تراکنش
                        </span>
                    </button>
                </div>
            </div>
            <CustomBottomSheet
                onDismiss={() => setIsOpen(false)}
                isOpen={isOpen}
            >
                <TransactionDetails
                    item={item}
                    isManager={isManager}
                    setIsOpen={() => setIsOpen(false)}
                />
            </CustomBottomSheet>
        </>
    )
}
